<template>
  <div class="verfiy-content">
    <div
      class="widgetContainer widgetContainer--center widgetContainer--full-screen appStatus appStatus--verifying verifyOnfido">
      <div class="widgetContainer__body">
        <LottieAnimation animation-name="searching" reference="kyc-status-review-1" :loop="true" />
        <p class="title">
          {{ $t('verifyOnfido_title') }}
        </p>
        <p class="description">
          {{ $t('verifyOnfido_desc') }}
        </p>
        <div class="widgetContainer__footer--fixed">
          <el-button
            type="primary"
            class="welcome__get-started el-button__brand brand"
            @click="proceed">
            {{ $t('verifyOnfido_buttonTitle') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import LottieAnimation from '@/components/LottieAnimation.vue';

export default {
  components: {
    LottieAnimation
  },
  computed: {
    ...mapGetters(['getActiveEnv']),
    ...mapGetters('user', [
      'getPersonDetails',
      'getProgramDetails',
      'getAccessToken',
      'getBrandColor'
    ]),
    ...mapGetters('kyc', ['getOnfidoDetails']),
    ...mapGetters('user', ['getUserAuthToken'])
  },
  data() {
    return {
      onfidoOut: null
    };
  },
  methods: {
    ...mapActions('kyc', ['fetchVerificationToken', 'submitKyc', 'idvSubmit']),
    proceed() {
      const person = this.getPersonDetails;
      const loader = this.showLoader();
      let payload = {
        personId: person.id,
        params: {
        }
      };
      this
        .idvSubmit(payload)
        .then((res) => {
          setTimeout(() => {
            this.startPersona(res.url);
          }, 0);
        })
        .catch((e) => {
          console.log(e);
          this.apiErrorMessage(e);
        })
        .finally(() => {
          loader.close();
        });
      
      window.analytics && window.analytics.track('proceedIdentity');
    },
    startPersona(url) {
      //store session
      window.sessionStorage.setItem('app_env', this.getActiveEnv)
      window.sessionStorage.setItem('user_auth_tokens', JSON.stringify(this.getUserAuthToken));
      window.sessionStorage.setItem('device_id', this.$http.defaults.headers.common['SD-Device-ID']);
      window.sessionStorage.setItem('shifl_auth_token', JSON.stringify(this.getAuthToken));
      window.location.href = url + '&redirect-uri='+window.location.origin + '/kyc/idv-callback';
    },
    startKYC() {
      /** @type {import('@/modules/user/store/state').userState['personDetails']} */
      const person = this.getPersonDetails;
      if (person && person.id) {
        const loader = this.showLoader();
        this.submitKyc(person.id)
          .then(() => {
            this.$router.push('/kyc/kycStatus');
          })
          .catch((e) => {
            console.log(e);
            this.apiErrorMessage(e);
          })
          .finally(() => {
            loader.close();
          });
      }
    }
  }
}
</script>
